export enum TabsEnum {
  COMPANY_INFO = 'company-info',
  PAYMENT_HISTORY = 'payment-history',
  ANALYTICS = 'analytics',
  EDIT = 'edit',
}
